import { render, staticRenderFns } from "./GrupeStatusa.vue?vue&type=template&id=0b733532&scoped=true&"
import script from "./GrupeStatusa.vue?vue&type=script&lang=js&"
export * from "./GrupeStatusa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b733532",
  null
  
)

export default component.exports